<template>
  <div id="app">
    <div class="pn-page-container">
      <pn-side-menu
        type="business"
        highlight-id="postal-services"
      ></pn-side-menu>
      <div id="main-view" class="landing-page-mailouts">
        <div id="mailout-menu">
          <pn-tablist id="nav" @tabchange="tabChange" :value="activeTab">
            <pn-tab
              v-for="(route, i) in routes"
              :key="i"
              :label="$t(route.text)"
              :value="route.name"
              v-show="route.show"
            >
              <pn-icon :symbol="route.symbol"></pn-icon>
            </pn-tab>
          </pn-tablist>
        </div>
        <transition name="page-transition" mode="out-in">
          <router-view class="view-container" />
        </transition>
        <br />
        <pn-footer></pn-footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      mailoutRoutes: ['letter']
    }
  },
  computed: {
    ...mapGetters(['isBusinessUser', 'isLoggedIn']),
    ...mapGetters('growthbook', ['isRVRedirectEnabled']),
    ...mapState(['mailoutCurrentRoute']),
    ...mapState('letter/pay', ['paymentStatus', 'orderActivated']),
    isMailoutRoute() {
      const routePath = this.$route.path || ''

      return this.mailoutRoutes.some(x => routePath.includes(x))
    },
    activeTab() {
      if (this.isMailoutRoute) {
        return 'currentMailout'
      }

      const routeName = this.$route.name || ''
      const currentRoute = this.getRouteByName(routeName)

      if (currentRoute) {
        return currentRoute.name
      }

      return currentRoute ? currentRoute.name : ''
    },
    routes() {
      return [
        {
          text: 'W2P_V2_NAVIGATION_CREATE',
          symbol: 'plus-circle',
          name: 'landing',
          route: '/',
          show: !this.isRVRedirectEnabled
        },
        {
          text: 'W2P_V2_NAVIGATION_ORDERS',
          symbol: 'envelope',
          name: 'myOrders',
          route: '/order/list',
          show: this.isLoggedIn
        },
        {
          text: 'W2P_V2_NAVIGATION_CURRENT_MAILOUT',
          symbol: 'bolt',
          name: 'currentMailout',
          route: this.mailoutCurrentRoute,
          show: this.mailoutCurrentRoute && !this.isRVRedirectEnabled
        }
      ]
    }
  },
  watch: {
    $route(to, from) {
      if (this.isMailoutRoute) {
        this.SET_MAILOUT_CURRENT_ROUTE(to.path)
      }
    }
  },
  mounted() {
    window.onscroll = this.onScroll
  },
  methods: {
    ...mapMutations(['SET_MAILOUT_CURRENT_ROUTE']),
    tabChange(e) {
      const newRoute = this.getRouteByName(e.target.value)

      // Reset flow when order has been placed and activated
      if (
        newRoute.name === 'landing' &&
        this.paymentStatus === 'success' &&
        sessionStorage.getItem('orderPlaced') &&
        this.orderActivated
      ) {
        this.$store.dispatch('resetOrderState')
      }

      this.$router.push(newRoute.route)
    },
    getRouteByName(name) {
      return this.routes.find(route => route.name === name)
    },
    onScroll() {
      const menu = document.getElementById('mailout-menu')
      const parentOffset = document.getElementById('main-view').offsetParent
      const rect = parentOffset.getBoundingClientRect()

      if (rect.top < 0) {
        menu.classList.add('sticky')
      }

      if (rect.top > 0) {
        menu.classList.remove('sticky')
      }
    }
  }
}
</script>

<style lang="scss">
*,
*::before,
*::after {
  box-sizing: border-box;
}

#mailout-menu {
  width: 100%;
  padding-top: 1.6rem;
  background-color: white;
  #nav {
    justify-content: center;

    .pn-tablist {
      pn-tab:first-child {
        margin-left: 4em;
      }

      pn-tab {
        margin-right: 2em;
      }
    }
  }

  &.sticky {
    position: fixed;
    top: 0;
    z-index: 2;

    & + .view-container {
      margin-top: 3.5em;
    }
  }
}

html {
  height: 100%;
  font-size: 62.5%; /* sets 1rem to 10px */
}

body {
  font-size: 1.6rem; /* ~16px */
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
}

pn-footer {
  margin-bottom: 6em;
  margin-top: 4em;
}

#app {
  width: 100%;
}

.view-container {
  flex-direction: column;
  min-height: 80%;
  max-width: 75em;
  margin: 0 auto;
  padding: 3.5rem 6.5rem;
}

.landing-page-mailouts {
  margin: 0;
  padding: 0;
  width: 100%;
  max-width: unset;
  overflow: hidden; //This is important for responsiveness
  // To keep the footer at the bottom of the page
  display: flex;
  flex-direction: column;
}

.service-header {
  margin-bottom: 6em;

  .header {
    color: #1e1e1e;
    font-size: 2em;
    font-weight: 500;
  }

  .subheader {
    color: #757575;
    font-size: 1em;
  }
}

@media screen and (max-width: 40em) {
  .view-container {
    padding: 1.5em 1.5em;
  }

  pn-tab:last-child {
    margin-right: 3em !important;
  }
}

@media screen and (max-width: 55em) {
  #mailout-menu.sticky {
    position: relative;

    & + .view-container {
      margin-top: 0;
    }
  }
}
</style>
